/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
'use strict'

$(document).ready(function($){

//   var lastScrollTop = 0;
//   $(window).scroll(function(event){
//     var st = $(this).scrollTop();
//     if (st > lastScrollTop){
//       $('.shopify-section--header').removeClass('fixed--header');
//     } else if(st < 10) {
//       $('.shopify-section--header').removeClass('fixed--header');
//     } else {
//       $('.shopify-section--header').addClass('fixed--header');
//     }
//     lastScrollTop = st;
//   });

  const Media = $(window).width();
  
  
  
  function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
      var context = scope || this;

      var now =+ new Date,
          args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  }

 
  jQuery('.Product__Info .container').one("DOMSubtreeModified",function(){ 
    $('#wishlisthero-product-page-button-container').appendTo('.ProductForm__QuantitySelector');
    $('#wishlisthero-product-page-button-container').css({'display':'inherit'});
  });
  
  $('.template-collection .breadcrumbs').insertBefore('.template-collection .PageHeader .Container');
  


  let selectSorting = $('.Popover__Content .Popover__ValueList .Popover__Value.is-selected').text().trim();
  $('.CollectionToolbar__Item--sort').html(`<span>Sort By: </span> ${selectSorting} <svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">
<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
</svg>`);



  $('.Popover__Content .Popover__Value').on('click' , function(){
    let selectSorting = $(this).text().trim();
    console.log(selectSorting);
    $('.CollectionToolbar__Item--sort').html(`<span>Sort By: </span> ${selectSorting} <svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">
<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
</svg>`);
  });


  $('.wishlisthero-floating button').click(function(){
    let exist = $(this).attr('class');
    if (exist) $(this).find('svg path').css({'fill':'#2C3357'});
    else $(this).find('svg path').css({'fill':'red'});
  });
  
  $('.SizeSwatchList input').removeAttr('checked');
  let selected = [];
  $('.SizeSwatchList input:checked').each(function() {
    selected.push($(this).attr('name'));
    
    $('.ProductForm__AddToCart').click(function(e){
      if(selected.length === 0){
		e.preventDefault();
        $('.size-err-msg').show();
      } else {
      	$('.size-err-msg').hide();
      }
    })

  });


  $('.Footer__Inner .index_no_3,.Footer__Inner .index_no_4').appendTo('.Footer__Inner .index_no_2 .Linklist');

  if(Media > 1007) $('.CollectionToolbar.CollectionToolbar--top').insertAfter('header.PageHeader .Container');
  
//    $('ul.Footer__Social').insertBefore('.Footer__Inner .index_no_1');





  function addToBag(){
    let collectionImage = parseInt($('.template-collection .ProductItem__Image').outerHeight()),
        topOffset = collectionImage - parseInt($('.collection_add_button').outerHeight());
    $('.collection_add_button').css({
      'top': topOffset
    })
  }
  addToBag();

  $(window).resize(function(){
    addToBag();
  })

  $('.template-collection .ProductItem__Image').hover(function(){
    $(this).parent('.ProductItem').find('.collection_add_button').toggleClass('show-button');
  })


  $('div#duplicate__variants button').click(function(){

    $(this).addClass('active--variant');
    $(this).siblings().removeClass('active--variant');
    let selectedvariant = $(this).attr('value');

    let originalSelect = $(this).closest('.ProductItem__Info').find('form .product-form__variants option');
    let originalSelectL = $(this).parent().next('form').find('.product-form__variants option').length;

    let data_match,
        originalmatch;

    originalSelect.each(function(){
      originalmatch = $(this).attr('data-match');
      $(this).removeAttr('selected', 'selected');

      if($.trim(selectedvariant).toLowerCase() == $.trim(originalmatch).toLowerCase()){
        $(this).attr('selected', 'selected');
      } 
    }); 
  });  


  $('.ProductItem__Wrapper .ProductItem__ImageWrapper').hover(function(){
    $(this).parent().find('form .collection_add_button').toggleClass('VISIBLE')
  })


  $(".view__similar").click(function() {
    $('html, body').animate({
      scrollTop: $("#shopify-section-template--14962649465021__163030535619d528e7").offset().top - 100
    }, 1000);
  });
  
  $(document).on('scroll', throttle(function (event) {
      addToBag();
  }, 1000));

});

// Create an Intersection Observer object
const options = {
  root: null, // viewport
  rootMargin: "0px", // margin around the viewport
  threshold: 0.8, // percentage of the target element that needs to be visible
};

const observer = new IntersectionObserver(callback, options);
let observedProductCards = [];

// Define the callback function
function callback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Element is in the viewport
      const productItem = entry.target;

      // Extract data from the grid__item grid-product element (customize this part)
      const productId = productItem.getAttribute("data-product-id");
      const productName = productItem.getAttribute("data-product-name");
      const productPrice = productItem.getAttribute("data-product-price");
      const productVendor = productItem.getAttribute("data-product-vendor");
      const productVariant = productItem.getAttribute("data-product-variant");
      const productCollection = productItem.getAttribute(
        "data-product-collection"
      );
      const CollectionId = productItem.getAttribute("data-collection-id");
      const indexNumber = productItem.getAttribute("product-index-number");

      observedProductCards.push({
        item_id: productId,
        item_name: productName,
        index: indexNumber,
        item_brand: productVendor,
        item_list_id: CollectionId ? CollectionId : "home",
        item_list_name: productCollection ? productCollection : "home",
        item_variant: productVariant,
        price: productPrice,
        quantity: 1,
      });

      if (observedProductCards.length >= 2) {
        console.log(observedProductCards);
        // Push the data into the dataLayer for a group of 4 product cards
        gtag("event", "view_item_list", {
          send_to: "G-GD40NCRBQV",
          item_list_id: CollectionId ? CollectionId : "home",
          item_list_name: productCollection ? productCollection : "home",
          items: observedProductCards,
        });

        // Clear the observed product cards array
        observedProductCards = [];
      }

      // Unobserve the target element
      // observer.unobserve(productItem);
    }
  });
}

// Observe all elements with the class [grid__item grid-product]
const productItems = document.querySelectorAll(".Grid__Cell.product-discount");
productItems.forEach((productItem) => {
  observer.observe(productItem);
});

// GA Events Code Push on Click Product Cards Collection Page
document.addEventListener("DOMContentLoaded", function () {
  let collectionItems = document.querySelectorAll(".merca_plp_click");

  const handleClick = function () {
    const productName = this.getAttribute("data-product-name");
    const productId = this.getAttribute("data-product-id");
    const productVendor = this.getAttribute("data-product-vendor");
    const productVariant = this.getAttribute("data-product-variant");
    const productPrice = this.getAttribute("data-product-price");
    const productCollection = this.getAttribute("data-product-collection");
    const CollectionId = this.getAttribute("data-collection-id");
    const indexNumber = this.getAttribute("product-index-number");
    gtag("event", "select_item", {
      send_to: "G-GD40NCRBQV",
      item_list_id: CollectionId ? CollectionId : "home",
      item_list_name: productCollection ? productCollection : "home",
      items: [
        {
          item_id: productId,
          item_name: productName,
          index: indexNumber,
          item_brand: productVendor,
          item_list_id: CollectionId ? CollectionId : "home",
          item_list_name: productCollection ? productCollection : "home",
          item_variant: productVariant,
          price: productPrice,
          quantity: 1,
        },
      ],
    });
  };

  const attachEventListeners = () => {
    console.log("focus");
    Array.from(collectionItems).forEach(function (element) {
      element.addEventListener("click", handleClick);
    });
  };

  const removeEventListeners = () => {
    Array.from(collectionItems).forEach(function (element) {
      element.removeEventListener("click", handleClick);
    });
  };

  attachEventListeners();
});

